"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _Team = require("../constants/Team");
var _utils = require("../utils");
var _testIdContext = require("./testIdContext");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Test ID provider
 * @param { FC<TestIdProviderProps> } props - Props for configuring the test ID provider
 * @throws { Error } Throws an error if `team` is not provided or is invalid
 * @returns { JSX.Element }
 */
const TestIdProvider = /*#__PURE__*/(0, _react.memo)(({
  children,
  team,
  project
}) => {
  if (!team) {
    throw new Error("Property `team` wasn't provided. Test id cannot be generated without it.");
  }
  if (process.env.NODE_ENV !== 'production' && !Object.keys(_Team.Team).includes(team)) {
    throw new Error(`Provided team '${team}' isn't allowed. Please select predefined team.`);
  }
  const getTestId = (0, _react.useMemo)(() => (0, _utils.generateTestId)({
    team,
    project
  }), [team, project]);
  const getTestIdProps = (0, _react.useMemo)(() => (0, _utils.generateTestIdProps)({
    team,
    project
  }), [team, project]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testIdContext.Provider, {
    value: {
      getTestId,
      getTestIdProps
    },
    children: children
  });
});
var _default = exports.default = TestIdProvider;
//# sourceMappingURL=TestIdProvider.js.map